import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
} from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HoverImage from "react-hover-image/build";
import ReactStrapTable from "components/reactStrapTable";
import { cloneDeep, includes } from "lodash";

import useAxios from "hooks/useAxios";
import Drawer from "components/Drawer";
import commonColumns, {
  dateFormate,
  currencyFormat,
  cellRendererCheck,
} from "utils/columns";
import FaxSentIcon from "assets/icon/faxSent.svg";
import FaxSentIconHover from "assets/icon/faxSent-hover.svg";
import ClaimHistory from "components/ClaimHistory";
import { GlobalComments } from "components/Comments";
import NPIPorviderEdit from "components/NPIPorviderEdit";
import FaxReceivedIcon from "assets/icon/faxReceived.svg";
import FaxReceivedIconHover from "assets/icon/FaxReceivedIcon-Hover.svg";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import HistoryIcon from "assets/icon/icon-icon-options-history.svg";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import HistoryHoverIcon from "assets/icon/icon-icon-options-history_hover.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import ToolTip from "react-tooltip-lite";
import FaxViewer from "components/FaxViewer";
import { ModuleAccess } from "utils/moduleaccess";
import Mapicon from "assets/icon/MapIcon.svg";
import MapIconHover from "assets/icon/MapIconHover.svg";
import DragDrop from "components/DragDrop";
import { onExport, getUpdatedFilterLatest } from "utils/helper";
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";

let tableDataBackup = [],
  rowForEdit = {},
  updatedFields = {};
let disabledClaimStatusReasons = [
  "Reversal Received",
  "Duplicate Reversal Received ",
  "Reversal With No Paid",
];
let allowedClaimStatusReasons = [
  "Reversal Received",
  "Duplicate Reversal Received ",
];

let autoselectlist1 = [];
let numberlist = [
  "Qty Dispensed",
  "Drug Cost 340B",
  "Profit/Loss",
  "RCS Fee",
  "Fax Count",
  "Days Supply",
  "GCN Sequence Number",
  "Total Paid",
  "Dispensing Fee",
  "CE Receivable",
  'Refill Number'
];
let currencylist = [
  "Drug Cost 340B",
  "CE Receivable",
  "Total Paid",
  "Dispensing Fee",
  "Profit/Loss",
  "RCS Fee Amount",
];
let dateList = [
  "Patient DOB",
  "Date Rx Written",
  "Date of Service",
  "Created Date",
  "Completed Date",
  "Invoiced Date",
  "Modified Date",
  "Status Change Date",
];
let editlist = ["Claim Status", "Reason"];
let hideColFilterlist = [
  "OPA Code",
  "Covered Entity Name",
  "Claim Status",
  "Reason",
  "RCS Fee Amount",
  "Eligible Visit",
  "Provider First Name",
  "Provider Last Name",
  "Provider Specialty",
  "Provider Status",
  "Phone Number",
  "Fax Count",
  "Pharmacy Name",
  "ThirdPartyAdmin",
  "Created By",
  "Status Change Date",
  "Completed By",
  "Invoiced By",
  "Net Savings",
  "Fax Number",
];

let sortingList = [
  "OPA Code",
  "Covered Entity Name",
  "Claim Status",
  "Reason",
  "RCS Fee Amount",
  "Eligible Visit",
  "Provider First Name",
  "Provider Last Name",
  "Provider Specialty",
  "Provider Status",
  "Fax Count",
  "Pharmacy Name",
  // "Created Date",
  "Phone Number",
  "ThirdPartyAdmin",
  "Created By",
  "Completed Date",
  "Status Change Date",
  "Status Changed By",
  "Completed By",
  "Invoiced Date",
  "Invoiced By",
  "Modified By",
  "Fax Number",
  // "Modified Date",
  "Net Savings",
];


const ClaimsManagerTable = (props) => {
  const {
    data,
    totalSize,
    onPageChange,
    filters,
    onSearchColumnFilters = () => "",
    AllExport,
    coveredEntity,
    refetch,
    module,
    manvalPatient,
    toggleSider,
    collapseSider,
    onManualbulkUpdate,
    orgId,
    showpatientdetails,
    setShowPatientDetails,
    patientIDNAME,
    setPatientIdName,
    resetFlag,
    SetResetFlag
  } = props;
  const API = useAxios();
  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);

  const [reset, setReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [drawer, setDrawer] = useState("");
  const [providerId, setProviderId] = useState("");
  const [commentDrawer, setCommentDrawer] = useState(false);
  const [commentRowData, setCommentRowData] = useState({});
  const { coveredEntityID, tenantID } = coveredEntity;
  const [hasStatusChanged, setSelectedStatus] = useState("");
  const [hasTouched, setTouched] = useState("");
  const [isOpenHistory, setOpenHistory] = useState(false);
  const [claimID, setClaimID] = useState("");
  const [colFilters, setColFilters] = useState({});
  const [pdfModal, setPdfModel] = useState(false);
  const [fax, setFaxDetail] = useState({});
  const [coloumselect, setColoumselect] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);

  useEffect(() => {
    handlAutocoloms();
  }, []);
  useEffect(() => {
    setHasExportPermission(ModuleAccess("CLM", "EXP"));
  }, []);

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const toggleHistory = (rowData) => {
    setOpenHistory(!isOpenHistory);
    setClaimID(rowData.claimID || "");
  };
  const hasPermission = (code) => {
    return ModuleAccess("CLM", code);
    //return (module && module.actions.indexOf(code) != -1)
  };

  const renderHistoryButton = (rowData) => {
    if (hasPermission("HI"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleHistory(rowData)}
        >
          <HoverImage
            key="HistoryIcon"
            src={HistoryIcon}
            hoverSrc={HistoryHoverIcon}
            alt=""
          />
        </Button>
      );
  };

  const cellRenderNetpeofit = (row) => {
    const { netProfit } = row;
    if (netProfit) {
      return (
        <span title="Net Savings =  Profit/Loss - RCS Fee Amount">
          {currencyFormat(netProfit)}
        </span>
      );
    }
    return "-";
  };

  const renderEditButton = (rowData) => {
    if (hasPermission("ED"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => editRow(rowData)}
          hidden={
            rowData.claimType == "R" ||
            disabledClaimStatusReasons.includes(rowData.reasonDesc) ||
            rowData.claimStatusID == 15 ||
            (rowData.reasonDesc == "Close Match" &&
              rowData.claimStatusID == 2 &&
              rowData.patientID == null)
          }
        >
          <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
        </Button>
      );
  };
  const renderCommentsButton = (rowData) => {
    if (hasPermission("AT"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleCommentDrawer(rowData)}
        >
          <HoverImage
            key="AttachIcon"
            src={AttachIcon}
            hoverSrc={AttachHoverIcon}
            alt=""
          />
        </Button>
      );
  };
  const renderpatient = (rowdata) => {
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        hidden={
          rowdata.claimStatusID == 15 ||
          allowedClaimStatusReasons.includes(rowdata.reasonDesc)
        }
        color="link"
        onClick={() => handlePatientnotFound(rowdata)}
      >
        <HoverImage
          key="Mapicon"
          src={Mapicon}
          hoverSrc={MapIconHover}
          alt=""
        />
      </Button>
    );
  };
  const cellRenderEdit = (rowData) => {
    if (rowData.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={saveUpdateRow}
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center">
          {renderEditButton(rowData)}
          {renderCommentsButton(rowData)}
          {renderHistoryButton(rowData)}
          {renderpatient(rowData)}
          {rowData.isFaxSent && (
            <div className="p-0 ms-0">
              <Button
                className="text-primary p-0 text-decoration-none"
                color="link"
                onClick={() => previewFaxInfo(rowData, "outboundfax")}
              >
                <HoverImage
                  key="FaxSentIcon"
                  src={FaxSentIcon}
                  hoverSrc={FaxSentIconHover}
                  alt=""
                />
              </Button>

              {/* <img src={FaxSentIcon} alt='fax sent' /> */}
            </div>
          )}
          {rowData.isFaxReceived && (
            <div className="p-0 ms-0">
              <Button
                className="text-primary p-0 text-decoration-none"
                color="link"
                onClick={() => previewFaxInfo(rowData, "inboundfax")}
              >
                <HoverImage
                  key="FaxReceivedIcon"
                  src={FaxReceivedIcon}
                  hoverSrc={FaxReceivedIconHover}
                  alt=""
                />

              </Button>
              {/*<img src={FaxReceivedIcon} alt='fax received' />*/}
            </div>
          )}
        </div>
      );
    }
  };

  const previewFaxInfo = async (row, faxdirection) => {
    try {
      let payload = {};
      payload.FaxDetailID =
        faxdirection === "outboundfax"
          ? row.outboundLastFaxId
          : row.inboundLastFaxId;
      const result = await API.post(
        `/${tenantID}/fax/patientfaxinfo/${coveredEntityID}`,
        payload
      );

      if (result) {
        setPdfModel(!pdfModal);
        setFaxDetail(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const togglePdfModal = () => {
    setPdfModel(!pdfModal);
  };

  const handlClick = (id) => {
    if (hasPermission("PC")) {
      setShowPatientDetails(true)
      // let value=id.toString()
      setPatientIdName(id)
    }

    // navigate(
    //   `/claims-manager/${coveredEntityID}/${tenantID}/${true}/patient/${id}`
    // );
  };

  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  };

  const formatter = (row) => {
    const {
      patientID,
      patientFirstName,
      ndc,
      drugName,
      providerFirstName,
      providerSpecialty,
      providerLastName,
      qtyDispensed,
      dateRXWritten,
      totalPaid,
      dispensingFee,
      ceReceivable,
      drugCost340B,
      profitLoss,
      dateofService,
      providerComments,
    } = row;
    if (hasPermission("PC"))
      if (row.reasonDesc == "Close Match") {
        return (
          <ToolTip
            content={
              <div className="tip-list-info">
                <p>
                  NDC <span> {ndc} </span>
                </p>
                <p>
                  Drug Name<span> {drugName} </span>
                </p>
                <p>
                  Dispensed Qty <span> {qtyDispensed} </span>
                </p>
                <p>
                  Date Rx Written <span> {dateFormate(dateRXWritten)} </span>
                </p>
                <p>
                  Date of Service <span> {dateFormate(dateofService)} </span>
                </p>
                <p>
                  Total Paid <span> {currencyFormat(totalPaid)} </span>
                </p>
                <p>
                  Dispensing Fee <span> {currencyFormat(dispensingFee)} </span>
                </p>
                <p>
                  CE Receivable <span> {currencyFormat(ceReceivable)} </span>
                </p>
                <p>
                  340B Drug Cost <span> {currencyFormat(drugCost340B)} </span>
                </p>
                <p>
                  Profit/Loss <span> {currencyFormat(profitLoss)} </span>
                </p>
                <p>
                  Provider Name{" "}
                  <span> {providerFirstName + " " + providerLastName} </span>
                </p>
                <p>
                  Provider Specialty<span> {providerSpecialty} </span>
                </p>
                <p>
                  Provider Comments{" "}
                  <span> {cellRendererCheck(providerComments)} </span>
                </p>
              </div>
            }
            direction="down"
            tagName="span"
            className="target"
            tipContentClassName=""
          >
            <span className="cursor-pointer text-decoration-underline">
              {patientFirstName}
            </span>
          </ToolTip>
        );
      }

    return (
      <ToolTip
        content={
          <div className="tip-list-info">
            <p>
              NDC <span> {ndc} </span>
            </p>
            <p>
              Drug Name<span> {drugName} </span>
            </p>
            <p>
              Dispensed Qty <span> {qtyDispensed} </span>
            </p>
            <p>
              Date Rx Written <span> {dateFormate(dateRXWritten)} </span>
            </p>
            <p>
              Date of Service <span> {dateFormate(dateofService)} </span>
            </p>
            <p>
              Total Paid <span> {currencyFormat(totalPaid)} </span>
            </p>
            <p>
              Dispensing Fee <span> {currencyFormat(dispensingFee)} </span>
            </p>
            <p>
              CE Receivable <span> {currencyFormat(ceReceivable)} </span>
            </p>
            <p>
              340B Drug Cost <span> {currencyFormat(drugCost340B)} </span>
            </p>
            <p>
              Profit/Loss <span> {currencyFormat(profitLoss)} </span>
            </p>
            <p>
              Provider Name{" "}
              <span> {providerFirstName + " " + providerLastName} </span>
            </p>
            <p>
              Provider Specialty<span> {providerSpecialty} </span>
            </p>
            <p>
              Provider Comments{" "}
              <span> {cellRendererCheck(providerComments)} </span>
            </p>
          </div>
        }
        direction="down"
        tagName="span"
        className="target"
        tipContentClassName=""
      >
        <span
          className="cursor-pointer text-decoration-underline"
          onClick={() => handlClick(patientID)}
        >
          {patientFirstName}
        </span>
      </ToolTip>
    );
  };
  useEffect(() => {
    if (commentDrawer == true) {
      setCommentDrawer(false)
    }
    if (isOpenHistory == true) {
      setOpenHistory(!isOpenHistory);

    }
    if (pdfModal == true) {
      setPdfModel(false)
    }
    if (isOpen == true) {
      setIsOpen(false)
    }

  }, [orgId])
  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setDrawer("");
  };

  const drawerClose = (hasUpdated) => {
    setIsOpen(!isOpen);
    setDrawer("");
    if (hasUpdated) refetch();
  };

  const handleProviderNPI = ({ providerNPI }) => {
    setIsOpen(!isOpen);
    setDrawer("npi");
    setProviderId(providerNPI);
  };

  const cellRenderProviderNPI = (row) => {
    const { providerNPI } = row;
    if (providerNPI) {
      if (hasPermission("PRD"))
        return (
          <span
            className="cursor-pointer text-decoration-underline"
            onClick={() => handleProviderNPI(row)}
          >
            {providerNPI}
          </span>
        );
      return <span>{providerNPI}</span>;
    }
    return "-";
  };

  // const cellRenderDrug340 = (row) => {
  //   const { drugCost340B } = row  ;
  //   return (
  //     <ToolTip content={(
  //       <div className='tip-list-info'>
  //         <p><span>This represents the actual replenished drug cost, calculated once the replenishment has been received. Before that, the cost is only an estimate </span></p>

  //       </div>
  //     )}
  //       direction="down"
  //       tagName="span"
  //       className="target"
  //       tipContentClassName="">
  //       <span
  //         className='cursor-pointer text-decoration-underline'
  //       >
  //         {drugCost340B}
  //       </span>
  //     </ToolTip>

  //   )

  // };

  const saveUpdateRow = async () => {
    try {
      const postData = {
        claimID: rowForEdit["claimID"],
        statusID: updatedFields["claimStatusID"]
          ? parseInt(updatedFields["claimStatusID"])
          : "",
        reasonDesc: updatedFields["reasonDesc"] || rowForEdit["reasonDesc"],
      };
      if (
        !hasStatusChanged ||
        !postData.reasonDesc ||
        !postData.claimID ||
        !postData.statusID
      ) {
        setTouched(true);
        return;
      }
      const { data } = await API.post(
        `/${tenantID}/Claim/UpdateStatus`,
        postData
      );
      if (data) {
        toast.success("Updated Successfully!");
        if (onSearchColumnFilters) {
          onSearchColumnFilters(colFilters);
        }
        //refetch();
      } else {
        console.log(" error ", data);
      }
    } catch (err) {
      toast.error("An error occurred");
      console.error(err);
    }
  };

  const updateRowValue = (value, col) => {
    updatedFields[col] = value;
    if (col === "claimStatusID") {
      setSelectedStatus(parseInt(rowForEdit.claimStatusID) !== parseInt(value));
    }
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.claimID === rowData?.claimID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setTouched("");
    setSelectedStatus("");
    updatedFields = {};
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellEditRender = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        hasTouched={hasTouched}
        requiredFields={["statusList", "text"]}
      />
    );
  };

  let maincol1 = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[0]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[0]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[0]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[0]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[0]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[0]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[0]?.text)
          ? "number"
          : "text",
      width: 160,
      hideColFilter: hideColFilterlist.includes(autoselectlist1[0]?.text)
        ? true
        : false,
      action: true,
      sort: !sortingList.includes(autoselectlist1[0]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[1]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[1]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[1]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[1]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[1]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[1]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 160,
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[1]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[1]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[1]?.text) ? true : false,
      sort: !sortingList.includes(autoselectlist1[0]?.text)
        ? true
        : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[2]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[2]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[2]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[2]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[2]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[2]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[2]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[2]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[2]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[3]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[3]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[3]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[3]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[3]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[3]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: !sortingList.includes(autoselectlist1[3]?.text)
        ? true
        : false,
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[3]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[3]?.text)
        ? true
        : false,
      action: true,
      width: 160,
      edit: editlist.includes(autoselectlist1[3]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[4]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[4]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[4]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[4]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[4]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[4]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[4]?.text)
          ? "number"
          : "text",
      width: 160,
      sort: !sortingList.includes(autoselectlist1[4]?.text)
        ? true
        : false,
      hideColFilter: hideColFilterlist.includes(autoselectlist1[4]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[5]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[5]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[5]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[5]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[5]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[5]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[5]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[5]?.text)
        ? true
        : false,
      action: true,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[5]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[6]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[6]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[6]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[6]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[6]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[6]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[6]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[6]?.text)
        ? true
        : false,
      action: true,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[6]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[7]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[7]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[7]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[7]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[7]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[7]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[7]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[7]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[7]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[8]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[8]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[8]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[8]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[8]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[8]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[8]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[8]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[8]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[9]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[9]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[0]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[9]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[9]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[9]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[9]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[9]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[9]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[10]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[10]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[10]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[10]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[10]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[10]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[10]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[10]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[10]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[11]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[11]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[11]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[11]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[11]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[11]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[11]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[11]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[11]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[12]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[12]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[12]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[12]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[12]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[12]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[12]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[12]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[12]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[12]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[13]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[13]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[13]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[13]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[13]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[13]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[13]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[13]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[13]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[14]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[14]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[14]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[14]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[14]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[14]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[14]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[14]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[14]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[15]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[15]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[15]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[15]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[15]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[15]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[15]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[15]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[15]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[16]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[16]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[16]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[16]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[16]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[16]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[16]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [16] ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[16]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[16]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[16]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[17]?.dataField,
      text: autoselectlist1[17]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[17]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[17]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[17]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[17]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[17]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[17]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[17]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [17] ? true : false,
      inputType: dateList.includes(autoselectlist1[17]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[17]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[17]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[17]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[17]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[18]?.dataField,
      text: autoselectlist1[18]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[18]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[18]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[18]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[18]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[18]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[18]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[18]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [18] ? true : false,
      inputType: dateList.includes(autoselectlist1[18]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[18]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[18]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[18]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[18]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[19]?.dataField,
      text: autoselectlist1[19]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[19]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[19]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[19]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[19]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[19]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[19]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[19]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [19] ? true : false,
      inputType: dateList.includes(autoselectlist1[19]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[19]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[19]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[19]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[19]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[20]?.dataField,
      text: autoselectlist1[20]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[20]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[20]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[20]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[20]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[20]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[20]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[20]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [20] ? true : false,
      inputType: dateList.includes(autoselectlist1[20]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[20]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[20]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[20]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[20]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[21]?.dataField,
      text: autoselectlist1[21]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[21]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[21]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[21]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[21]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[21]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[21]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[21]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [21] ? true : false,
      inputType: dateList.includes(autoselectlist1[21]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[21]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[21]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[21]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[21]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[22]?.dataField,
      text: autoselectlist1[22]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[22]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[22]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[22]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[22]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[22]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[22]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[22]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [22] ? true : false,
      inputType: dateList.includes(autoselectlist1[22]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[22]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[22]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[22]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[22]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[23]?.dataField,
      text: autoselectlist1[23]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[23]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[23]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[23]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[23]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[23]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[23]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[23]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [23] ? true : false,
      inputType: dateList.includes(autoselectlist1[23]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[23]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[23]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[23]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[23]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[24]?.dataField,
      text: autoselectlist1[24]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[24]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[24]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[24]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[24]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[24]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[24]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[24]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [24] ? true : false,
      inputType: dateList.includes(autoselectlist1[24]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[24]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[24]?.text)
        ? true
        : false,
      action: true,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[24]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[24]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[25]?.dataField,
      text: autoselectlist1[25]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[25]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[25]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[25]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[25]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[25]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[25]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[25]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [25] ? true : false,
      inputType: dateList.includes(autoselectlist1[25]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[25]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[25]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[25]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[25]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[26]?.dataField,
      text: autoselectlist1[26]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[26]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[26]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[26]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[26]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[26]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[26]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[26]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [26] ? true : false,
      inputType: dateList.includes(autoselectlist1[26]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[26]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[26]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[26]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[26]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[27]?.dataField,
      text: autoselectlist1[27]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[27]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[27]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[27]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[27]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[27]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[27]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[27]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [27] ? true : false,
      inputType: dateList.includes(autoselectlist1[27]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[27]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[27]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[27]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[27]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[28]?.dataField,
      text: autoselectlist1[28]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[28]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[28]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[28]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[28]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[28]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[28]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[28]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [28] ? true : false,
      inputType: dateList.includes(autoselectlist1[28]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[28]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[28]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[28]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[28]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[29]?.dataField,
      text: autoselectlist1[29]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[29]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[29]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[29]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[29]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[29]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[29]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[29]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [29] ? true : false,
      inputType: dateList.includes(autoselectlist1[29]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[29]?.text)
          ? "number"
          : "text",

      width: 160,
      hideColFilter: hideColFilterlist.includes(autoselectlist1[29]?.text)
        ? true
        : false,
      action: true,
      sort: !sortingList.includes(autoselectlist1[29]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[29]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[30]?.dataField,
      text: autoselectlist1[30]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[30]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[30]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[30]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[30]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[30]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[30]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[30]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [30] ? true : false,
      inputType: dateList.includes(autoselectlist1[30]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[30]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[30]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[30]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[30]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[31]?.dataField,
      text: autoselectlist1[31]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[31]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[31]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[31]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[31]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[31]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[31]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[31]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [31] ? true : false,
      inputType: dateList.includes(autoselectlist1[31]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[31]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[31]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[31]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[31]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[32]?.dataField,
      text: autoselectlist1[32]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[32]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[32]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[32]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[32]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[32]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[32]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[32]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [32] ? true : false,
      inputType: dateList.includes(autoselectlist1[32]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[32]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[32]?.text)
        ? true
        : false,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[32]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[32]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[33]?.dataField,
      text: autoselectlist1[33]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[33]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[33]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[33]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[33]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[33]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[33]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[33]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [33] ? true : false,
      inputType: dateList.includes(autoselectlist1[33]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[33]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[33]?.text)
        ? true
        : false,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[33]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[33]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[34]?.dataField,
      text: autoselectlist1[34]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[34]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[34]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[34]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[34]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[34]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[34]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[34]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [34] ? true : false,
      inputType: dateList.includes(autoselectlist1[34]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[34]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[34]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[34]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[34]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[35]?.dataField,
      text: autoselectlist1[35]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[35]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[35]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[35]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[35]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[35]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[35]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[35]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [35] ? true : false,
      inputType: dateList.includes(autoselectlist1[35]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[35]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[35]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[35]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[35]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[36]?.dataField,
      text: autoselectlist1[36]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[36]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[36]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[36]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[36]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[36]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[36]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[36]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [36] ? true : false,
      inputType: dateList.includes(autoselectlist1[36]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[36]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[36]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[36]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[36]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[37]?.dataField,
      text: autoselectlist1[37]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[37]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[37]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[37]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[37]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[37]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[37]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[37]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [37] ? true : false,
      inputType: dateList.includes(autoselectlist1[37]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[37]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[37]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[37]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[37]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[38]?.dataField,
      text: autoselectlist1[38]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[38]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[38]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[38]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[38]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[38]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[38]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[38]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [38] ? true : false,
      inputType: dateList.includes(autoselectlist1[38]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[38]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[38]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[38]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[38]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[39]?.dataField,
      text: autoselectlist1[39]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[39]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[39]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[39]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[39]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[39]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[39]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[39]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [39] ? true : false,
      inputType: dateList.includes(autoselectlist1[39]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[39]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[39]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      sort: !sortingList.includes(autoselectlist1[39]?.text)
        ? true
        : false,
      edit: editlist.includes(autoselectlist1[39]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[40]?.dataField,
      text: autoselectlist1[40]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[40]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[40]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[40]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[40]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[40]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[40]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[40]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [40] ? true : false,
      inputType: dateList.includes(autoselectlist1[40]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[40]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[40]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[40]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[40]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[41]?.dataField,
      text: autoselectlist1[41]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[41]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[41]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[41]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[41]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[41]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[41]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[41]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [41] ? true : false,
      inputType: dateList.includes(autoselectlist1[41]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[41]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[41]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[41]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[41]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[42]?.dataField,
      text: autoselectlist1[42]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[42]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[42]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[42]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[42]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[42]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[42]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[42]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [42] ? true : false,
      inputType: dateList.includes(autoselectlist1[42]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[42]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[42]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[42]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[42]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[43]?.dataField,
      text: autoselectlist1[43]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[43]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[43]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[43]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[43]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[43]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[43]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[43]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [43] ? true : false,
      inputType: dateList.includes(autoselectlist1[43]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[43]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[43]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[43]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[43]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[44]?.dataField,
      text: autoselectlist1[44]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[44]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[44]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[44]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[44]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[44]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[44]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[44]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [44] ? true : false,
      inputType: dateList.includes(autoselectlist1[44]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[44]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[44]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[44]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[44]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[45]?.dataField,
      text: autoselectlist1[45]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[45]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[45]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[45]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[45]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[45]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[45]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[45]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [45] ? true : false,
      inputType: dateList.includes(autoselectlist1[45]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[45]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[45]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[45]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[45]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[46]?.dataField,
      text: autoselectlist1[46]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[46]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[46]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[46]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[46]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[46]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[46]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[46]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [46] ? true : false,
      inputType: dateList.includes(autoselectlist1[46]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[46]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[46]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[46]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[46]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[47]?.dataField,
      text: autoselectlist1[47]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[47]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[47]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[47]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[47]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[47]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[47]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[47]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [47] ? true : false,
      inputType: dateList.includes(autoselectlist1[47]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[47]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[47]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[47]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[47]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[48]?.dataField,
      text: autoselectlist1[48]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[48]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[48]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[48]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[48]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[48]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[48]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[48]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [48] ? true : false,
      inputType: dateList.includes(autoselectlist1[48]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[48]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[48]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[48]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[48]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[49]?.dataField,
      text: autoselectlist1[49]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[49]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[49]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[49]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[49]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[49]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[49]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[49]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 160,
      show: autoselectlist1.length > [49] ? true : false,
      inputType: dateList.includes(autoselectlist1[49]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[49]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[49]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[49]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[49]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[50]?.dataField,
      text: autoselectlist1[50]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[50]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[50]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[50]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[50]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[50]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[50]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[50]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [50] ? true : false,
      inputType: dateList.includes(autoselectlist1[50]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[50]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[50]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[50]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[50]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[51]?.dataField,
      text: autoselectlist1[51]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[51]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[51]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[51]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[51]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[51]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[51]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[51]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [51] ? true : false,
      inputType: dateList.includes(autoselectlist1[51]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[51]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[51]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[51]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[51]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[52]?.dataField,
      text: autoselectlist1[52]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[52]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[52]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[52]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[52]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[52]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[52]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[52]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [52] ? true : false,
      inputType: dateList.includes(autoselectlist1[52]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[52]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[52]?.text)
        ? true
        : false,
      width: 160,
      sort: !sortingList.includes(autoselectlist1[52]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[52]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[53]?.dataField,
      text: autoselectlist1[53]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[53]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[53]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[53]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[53]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[53]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[53]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[53]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [53] ? true : false,
      inputType: dateList.includes(autoselectlist1[53]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[53]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[53]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[53]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[53]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[54]?.dataField,
      text: autoselectlist1[54]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[54]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[54]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[54]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[54]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[54]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[54]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[54]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [54] ? true : false,
      inputType: dateList.includes(autoselectlist1[54]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[54]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[54]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[54]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[54]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[55]?.dataField,
      text: autoselectlist1[55]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[55]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[55]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[55]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[55]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[55]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[55]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[55]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [55] ? true : false,
      inputType: dateList.includes(autoselectlist1[55]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[55]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[55]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[55]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[55]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[56]?.dataField,
      text: autoselectlist1[56]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[56]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[56]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[56]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[56]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[56]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[56]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[56]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [56] ? true : false,
      inputType: dateList.includes(autoselectlist1[56]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[56]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[56]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[56]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[56]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[57]?.dataField,
      text: autoselectlist1[57]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[57]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[57]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[57]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[57]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[57]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[57]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[57]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [57] ? true : false,
      inputType: dateList.includes(autoselectlist1[57]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[57]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[57]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[57]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[57]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[58]?.dataField,
      text: autoselectlist1[58]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[58]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[58]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[58]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[58]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[58]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[58]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[58]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [58] ? true : false,
      inputType: dateList.includes(autoselectlist1[58]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[58]?.text)
          ? "number"
          : "text",

      hideColFilter: hideColFilterlist.includes(autoselectlist1[58]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[58]?.text)
        ? true
        : false,
      width: 160,
      action: true,
      edit: editlist.includes(autoselectlist1[58]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[59]?.dataField,
      text: autoselectlist1[59]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[59]?.text)
        ? (rowData, col) => currencyFormat(rowData[col.dataField])
        : dateList.includes(autoselectlist1[59]?.text)
          ? (rowData, col) => dateFormate(rowData[col.dataField])
          : autoselectlist1[59]?.text == "Claim Status"
            ? (rowData, col) => cellEditRender(rowData, col, "statusList")
            : autoselectlist1[59]?.text == "Reason"
              ? (rowData, col) => cellEditRender(rowData, col, "comments")
              : autoselectlist1[59]?.text == "Patient First Name"
                ? (rowData) => formatter(rowData)
                : autoselectlist1[59]?.text == "Provider NPI"
                  ? (rowData) => cellRenderProviderNPI(rowData)
                  : autoselectlist1[59]?.text == "Net Savings"
                    ? (rowData, col) => cellRenderNetpeofit(rowData)
                    : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 160,
      show: autoselectlist1.length > [59] ? true : false,
      inputType: dateList.includes(autoselectlist1[59]?.text)
        ? "date"
        : numberlist.includes(autoselectlist1[59]?.text)
          ? "number"
          : "text",
      hideColFilter: hideColFilterlist.includes(autoselectlist1[59]?.text)
        ? true
        : false,
      sort: !sortingList.includes(autoselectlist1[59]?.text)
        ? true
        : false,
      action: true,
      edit: editlist.includes(autoselectlist1[59]?.text) ? true : false,
    },
  ];

  let copyCommonColumns = cloneDeep(commonColumns);

  copyCommonColumns[4].cellRenderer = (row, col) =>
    cellEditRender(row, col, "statusList");
  copyCommonColumns[5].cellRenderer = (row, col) =>
    cellEditRender(row, col, "comments");
  copyCommonColumns[28].cellRenderer = cellRenderProviderNPI;
  //copyCommonColumns[23].cellRenderer = cellRenderDrug340;
  copyCommonColumns[26].cellRenderer = cellRenderNetpeofit;
  const handlePatientnotFound = async (rowdata) => {
    await manvalPatient(rowdata);
  };
  let mainCol = [
    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,

      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity Name',
      cellRenderer: (rowData) => cellRendererCheck(rowData.coveredEntityName),
      sort: false,
      width: 200,
      show: true,
      inputType: 'text',
      hideColFilter: true,
    },
    {
      dataField: 'opaCode',
      text: 'OPA Code',
      cellRenderer: (rowData) => cellRendererCheck(rowData.opaCode),
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
    },
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      cellRenderer: (rowData) => formatter(rowData),
      sort: true,
      width: 144,
      show: true,
      inputType: 'text',
    },
    // {
    //   dataField: 'patientFirstName',
    //   text: 'Patient First Name',
    //   cellRenderer: (rowData) => cellRendererCheck(rowData.patientFirstName),
    //   sort: true,
    //   width: 144,
    //   show: true,
    //   inputType: 'text',
    // },
    {
      dataField: 'patientLastName',
      text: 'Patient Last Name',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.patientLastName),
    },
    {
      dataField: 'patientDOB',
      text: 'Patient DOB',
      sort: true,
      width: 140,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData) => dateFormate(rowData.patientDOB),
    },
    {
      dataField: 'medicalRecordNumber',
      text: 'Medical Record Number',
      sort: true,
      width: 160,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.medicalRecordNumber),
    },
    {
      dataField: 'claimStatus',
      text: 'Claim Status',
      sort: false,
      // cellRenderer: (rowData) => cellRendererCheck(rowData.claimStatus),
      cellRenderer: (row, col) => cellEditRender(row, col, 'statusList'),
      width: 130,
      show: true,
      edit: true,
      inputType: 'text',
      hideColFilter: true,
    },
    {
      dataField: 'reasonDesc',
      text: 'Reason',
      sort: false,
      // cellRenderer: (rowData) => cellRendererCheck(rowData.reasonDesc),
      cellRenderer: (row, col) => cellEditRender(row, col, 'comments'),
      width: 150,
      show: true,
      edit: true,
      inputType: 'text',
      hideColFilter: true,
    },
    {
      dataField: 'rxNumber',
      text: 'RX Number',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.rxNumber),
    },
    {
      dataField: 'refillNumber',
      text: 'Refill Number',
      sort: true,
      width: 145,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRendererCheck(rowData.refillNumber),
    },
    {
      dataField: 'dateRXWritten',
      text: 'Date Rx Written',
      cellRenderer: (rowData) => dateFormate(rowData.dateRXWritten),
      sort: true,
      width: 120,
      show: true,
      inputType: 'date',
    },
    {
      dataField: 'dateofService',
      text: 'Date of Service',
      cellRenderer: (rowData) => dateFormate(rowData.dateofService),
      sort: true,
      width: 120,
      show: true,
      inputType: 'date',
    },
    {
      dataField: 'ndc',
      text: 'NDC',
      sort: true,
      width: 110,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
    },
    {
      dataField: 'drugName',
      text: 'Drug Name',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugName),
    },
    {
      dataField: 'qtyDispensed',
      text: 'Qty Dispensed',
      sort: true,
      width: 150,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRendererCheck(rowData.qtyDispensed),
    },
    {
      dataField: 'daysSupply',
      text: 'Days Supply',
      sort: true,
      width: 100,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRendererCheck(rowData.daysSupply),
    },
    {
      dataField: 'gcnSequenceNumber',
      text: 'GCN Sequence Number',
      sort: true,
      width: 150,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRendererCheck(rowData.gcnSequenceNumber),
    },
    {
      dataField: 'manufacturerName',
      text: 'Manufacturer Name',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.manufacturerName),
    },
    {
      dataField: 'drugStatusDesc',
      text: 'Drug Status Desc',
      sort: true,
      width: 165,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugStatusDesc),
    },
    {
      dataField: 'claimType',
      text: 'Claim Type',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimType),
    },
    {
      dataField: 'claimSubType',
      text: 'Claim Sub Type',
      sort: true,
      width: 120,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimSubType),
    },
    {
      dataField: 'sourceReason',
      text: 'Source Reason',
      sort: true,
      width: 120,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceReason),
    },
    {
      dataField: 'totalPaid',
      text: 'Total Paid',
      sort: true,
      width: 125,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => currencyFormat(rowData.totalPaid),
      className: 'text-end',
    },
    {
      dataField: 'dispensingFee',
      text: 'Dispensing Fee',
      sort: true,
      width: 125,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => currencyFormat(rowData.dispensingFee),
      className: 'text-end',
    },
    {
      dataField: 'ceReceivable',
      text: 'CE Receivable',
      sort: true,
      width: 145,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => currencyFormat(rowData.ceReceivable),
      className: 'text-end',
    },
    {
      dataField: 'drugCost340B',
      text: 'Drug Cost 340B',
      sort: true,
      width: 140,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => currencyFormat(rowData.drugCost340B),
      className: 'text-end',
    },
    {
      dataField: 'profitLoss',
      text: 'Profit/Loss',
      sort: true,
      width: 125,
      textAlign: 'right',
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => currencyFormat(rowData.profitLoss),
      className: 'text-end',
    },
    {
      dataField: "rcsFeeAmt",
      text: "RCS Fee Amount",
      cellRenderer: (rowData) => currencyFormat(rowData.rcsFeeAmt),
      sort: false,
      width: 170,
      show: true,
      inputType: 'number',
      className: 'text-end',
      hideColFilter: true,
    },
    {
      dataField: "netProfit",
      text: "Net Savings",
      cellRenderer: (rowData) => cellRenderNetpeofit(rowData),
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      className: 'text-end',
      hideColFilter: true,
    },
    {
      dataField: 'hasVisit',
      text: 'Eligible Visit',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',

      cellRenderer: (rowData) => cellRendererCheck(rowData.hasVisit),
      hideColFilter: true,
    },
    {
      dataField: 'providerNPI',
      text: 'Provider NPI',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRenderProviderNPI(rowData),
    },
    {
      dataField: 'providerFirstName',
      text: 'Provider First Name',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerFirstName),
    },
    {
      dataField: 'providerLastName',
      text: 'Provider Last Name',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerLastName),
    },
    {
      dataField: 'providerSpecialty',
      text: 'Provider Specialty',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerSpecialty),
      hideColFilter: true,
    },
    {
      dataField: 'providerStatus',
      text: 'Provider Status',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerStatus),
      hideColFilter: true,
    },
    {
      dataField: 'faxNumber',
      text: 'Fax Number',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxNumber),
    },
    {
      dataField: 'phoneNumber',
      text: 'Phone Number',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.phoneNumber),
    },
    {
      dataField: 'faxCount',
      text: 'Fax Count',
      sort: false,
      width: 130,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxCount),
    },
    {
      dataField: 'pharmacyNPI',
      text: 'Pharmacy NPI',
      sort: true,
      width: 145,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyNPI),
    },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy Name',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
    },
    {
      dataField: 'ThirdPartyAdminID',
      text: 'Third Party Admin',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.thirdPartyAdminID),
    },
    {
      dataField: 'bin',
      text: 'BIN',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.bin),
    },
    {
      dataField: 'pcn',
      text: 'PCN',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.pcn),
    },
    {
      dataField: 'groupNumber',
      text: 'Group Number',
      sort: true,
      width: 150,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.groupNumber),
    },
    {
      dataField: 'secondaryBIN',
      text: 'Secondary BIN',
      sort: true,
      width: 165,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryBIN),
    },
    {
      dataField: 'secondaryPCN',
      text: 'Secondary PCN',
      sort: true,
      width: 165,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryPCN),
    },
    {
      dataField: 'secondaryGroup',
      text: 'Secondary Group',
      sort: true,
      width: 130,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryGroup),
    },

    {
      dataField: 'createdDate',
      text: 'Created Date',
      sort: true,
      width: 160,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
    {
      dataField: 'createdBy',
      text: 'Created By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.createdBy),
      hideColFilter: true,
    },
    {
      dataField: 'claimStatusChangeDate',
      text: 'Status Change Date',
      sort: false,
      width: 125,
      show: true,
      hideColFilter: true,
      inputType: 'date',
      cellRenderer: (rowData) => dateFormate(rowData.claimStatusChangeDate),
    },
    {
      dataField: 'ClaimStatusChangeByID',
      text: 'Status Changed By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.statusChangedBy),
    },
    {
      dataField: 'completedDate',
      text: 'Completed Date',
      sort: false,
      width: 125,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData) => dateFormate(rowData.completedDate),
    },
    {
      dataField: 'completedBy',
      text: 'Completed By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.completedBy),
      hideColFilter: true,
    },
    {
      dataField: 'invoicedDate',
      text: 'Invoiced Date',
      sort: false,
      width: 125,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData) => dateFormate(rowData.invoicedDate),
    },
    {
      dataField: 'invoicedBy',
      text: 'Invoiced By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.invoicedBy),
      hideColFilter: true,
    },
    {
      dataField: 'modifiedDate',
      text: 'Modified Date',
      sort: true,
      width: 125,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
    },
    {
      dataField: 'ModifiedByID',
      text: 'Modified By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedBy),
    },
    {
      dataField: 'claimID',
      text: 'Claim ID',
      sort: true,
      width: 125,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimID),

    },
    {
      dataField: 'sourceClaimID',
      text: 'Source Claim ID',
      sort: true,
      width: 155,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceClaimID),

    },
    {
      dataField: 'claimReferenceID',
      text: 'Claim Reference ID',
      sort: true,
      width: 180,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimReferenceID),

    },

    // {
    //   dataField: 'drugcost340b',
    //   text: 'Drugcost340b',
    //   cellRenderer: (rowData) => formatter(rowData),
    //   sort: true,
    //   width: 144,
    //   show: true,
    //   inputType: 'text',
    // },
    // ...copyCommonColumns,
  ];

  // mainCol.splice(4, 1);

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {

    for (var x in colFilter) {
      if (colFilter[x].filterName == "statusChangedBy") {
        colFilter[x].filterName = "ClaimStatusChangeByID"
      }
      if (colFilter[x].filterName == "modifiedBy") {
        colFilter[x].filterName = "ModifiedByID"
      }
    }

    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      setColFilters(colFilter);
    }
  };
  const slelectedExportcoloumms = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Claim/SelectedExportAll?access_token=${access_token}`;
    onExport(action, filters);
  };

  const selectedExportcoloumns2 = async () => {
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = true;
    if (colFilters && colFilters.length > 0) {
      filters.filters = [...filters.filters, ...colFilters];
    }
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "claimsmanager";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filters);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


  const handleFilterCancel = () => {

    setColFilters();
    refetch(true);
  };

  const handleColumnFilterChanges = () => {

    // setColFilters();
    refetch();
  };

  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
    setCommentRowData(rowData);
  };
  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(
        `RCMConfig/coveredentity/autoselectcoloumslist`,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {

        for (var x in data) {
          autoselectlist1.push({
            text: data[x].displayName,
            dataField: data[x].fieldName,
          });
        }
      }
    } catch (err) { }
  };
  const selectedCoveredEntity = { tenantID: tenantID }
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="">
          <h5 className="f-16 text-primary font-weight-700 mb-0">
            Claims Manager Count ({totalSize})
          </h5>
        </div>
        <div>
          <Row>
            <Col xs="auto">
              <div
                className="togglesider ps-3 ms-3 "
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="claims-manager-table"
          height={550}
          fixedColumn
          width={1200}
          reset={reset}
          hasPagination
          data={tableData}
          columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
          AllExport={AllExport}
          filters={filters}
          slelectedExport={selectedExportcoloumns2}
          totalRecords={totalSize}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          hasExportPermission={hasExportPermission}
          hasColselect={true}
          onSelectColoums={handleselectColoums}
          resetFlag={resetFlag}
          SetResetFlag={SetResetFlag}
          autoselectlist1={autoselectlist1}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          claims={true}
          onManualbulkUpdate={onManualbulkUpdate}
        />
        <Drawer
          direction="end"
          isOpen={isOpen}
          toggle={toggleDrawer}
          title={`${drawer === "npi" ? "Update Provider (" + providerId + ")" : ""
            }`}
        >
          <NPIPorviderEdit
            tenantID={tenantID}
            providerId={providerId}
            coveredEntityID={coveredEntityID}
            onClose={drawerClose}
          />
        </Drawer>
        <Drawer
          direction="end"
          title="Attachments"
          isOpen={commentDrawer}
          toggle={toggleCommentDrawer}
          size="lg"
        >
          <GlobalComments
            tenantID={tenantID}
            row={commentRowData}
            coveredEntityID={coveredEntityID}
            providerID={commentRowData?.providerID}
            orgId={orgId}
          />
        </Drawer>
        <Modal
          isOpen={isOpenHistory}
          toggle={toggleHistory}
          size="xl"
          className="xl"
        >
          <ModalHeader toggle={toggleHistory}>
            <h4 className='font-weight-600 m-0' style={{ color: "#702C62", fontSize: "20px", }}>Claim({claimID}) History</h4>
          </ModalHeader>
          <div>
            <ClaimHistory tenantID={tenantID} claimID={claimID} />
          </div>
        </Modal>
        <Modal
          isOpen={coloumselect}
          toggle={handleselectColoums}
          size="lg"
          className="lg colum-sel"
        >
          <ModalHeader toggle={handleselectColoums}>
            Column Selector
          </ModalHeader>
          <ModalBody>
            <DragDrop
              cancalcolselect={handleselectColoums}
              refetch={handleColumnFilterChanges}
              reloadautocolum={handlAutocoloms}
            />
          </ModalBody>
        </Modal>

        <Drawer
          direction='end'
          isOpen={pdfModal}
          toggle={togglePdfModal}
          title='Fax View'
          size="lg">


          <FaxViewer selectedCoveredEntity={selectedCoveredEntity} hasReadOnly={true} fax={fax} faxview={fax}
            hideComments={true} toggle={togglePdfModal} claims={true}></FaxViewer>
        </Drawer>


        {/* <FaxViewer
          fax={fax}
          hasReadOnly={true}
          isOpen={pdfModal}
          toggle={togglePdfModal}
          selectedCoveredEntity={{ tenantID }}
          hideComments={true}
        /> */}

      </div>
    </div>
  );
};
export default ClaimsManagerTable;
